import { render, staticRenderFns } from "./SuggestionBox.vue?vue&type=template&id=f00834b2&"
import script from "./SuggestionBox.vue?vue&type=script&lang=js&"
export * from "./SuggestionBox.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f00834b2')) {
      api.createRecord('f00834b2', component.options)
    } else {
      api.reload('f00834b2', component.options)
    }
    module.hot.accept("./SuggestionBox.vue?vue&type=template&id=f00834b2&", function () {
      api.rerender('f00834b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuggestionBox.vue"
export default component.exports